<h2 class="title">My Todos</h2>
<button (click)="refreshSettings()">Refresh Settings</button>

<div>
  testFlag: {{testFlag()}}<br>
  this.todoService.testFlag(): {{todoService.testFlag()}}<br>
  this.settings.testFlag(): {{settings.testFlag()}}
</div>
@if(roleResource.isLoading()){
<div><span>Loading...</span></div>
}
@for(r of roleResource.value(); track r) {
<div>
  {{ r.name }}
</div>
}
<!-- <div>
  rResource.value(): {{rResource.value() | json}}
</div> -->
<hr>
<h2 class="title">User Roles</h2>

@if(rResource.isLoading()){
<div><span>Loading...</span></div>
}
<table>
  <tr>
    <th>Id</th>
  </tr>
  @for(r of userRoles(); track r.role_id) {
  <tr>
    <td>{{ r.role_id }}</td>
  </tr>
  }
</table>
<br>
<!-- <div *ngFor="let t of todos">
  <div>
    {{ t.name }}
  </div>
</div> -->

<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'list-check']"></fa-icon> Manage Roles
        </h3>
      </div>

      <kendo-grid [kendoGridBinding]="gridData()" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
        [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
        style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize" [pageable]="true">

        <ng-template kendoGridToolbarTemplate position="top">
          <button (click)="onAddRole()" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add Role
          </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Access Rights" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onEditPermisions(dataItem)" kendoButton class="btn btn-stn-grid" style="width: 70px;">
              <fa-icon icon="address-card"></fa-icon>
              <span> {{dataItem.permissionCnt}}</span>
            </button>
          </ng-template>

        </kendo-grid-column>

        <kendo-grid-column field="name" title="Name">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="canSelect" title="Organisation Selectable" [width]="250">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Delete" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

    </div>
  </div>

</div>
